<template>
    <div class="page white_bg">

        <header class="pageHeader paddingH16 paddingV8 white_bg">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <router-link to="/" class="icon leftAngleBracketIcon floatL"
                             style="margin-top: 3px;"></router-link>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold hiddenOverflow"
                         style="line-height: 30px;">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px"></div>
                </div>
            </div>
        </header>

        <div class="body">
            <div class="alignC" style="padding-top: 32px">
                <img src="icon/success_yellow_circle_icon.png" width="48" height="48"/>
            </div>
            <div class="alignC color101010 font18r marginT16">
                提交成功！
            </div>
            <div class="alignC color777 font12r marginT12" style="line-height: 16px;">
                亲爱的小主，您的提现申请已经提交成功，我们的工作人员将在5个
            </div>
            <div class="generalPagePaddingH" style="padding-top: 48px;">
                <router-link to="/" class="button block backButton">
                    返回首页
                </router-link>
            </div>
        </div><!-- end .body -->

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

const config = {
    name : 'requestSubmitSuccessTemplate',
    title : 'XX申请',
    description : ''
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {  },
    data () {
        return {
            title : config.title,
            description : config.description
        }
    }
}
</script>

<style lang="scss" scoped>
.backButton {
    height: 48px;
    line-height: 48px;
    border-radius: 24px;
    padding: 0;
    background: linear-gradient(90deg, #FFA115 0%, #FFBF60 100%);
    border: none;
    color: white;
}
</style>
